import styled from 'styled-components'
import * as theme from '../theme'

export const Select = styled.select`
   background: ${theme.color.white};
   padding: ${theme.spacing.s} ${theme.spacing.sm};
   border-radius: ${theme.border.radius};
   border: 1px solid ${theme.color.border};
   cursor: pointer;
   -webkit-appearance: none;
   max-width: ${props => (props.maxWidth ? props.maxWidth : 'auto')};

   &:hover,
   &:focus {
      border-color: ${theme.color.primary};
   }
`
